import React, {Component} from 'react';
import './App.css';

import {Container, Row, Col} from 'react-grid-system';
import Loading from "./Components/Loading";
import Cards from "./Components/Cards";
import Table from "./Components/Table";
import MaintenantCards from "./Components/MaintenantCards";
import MaintenantCardsV2 from "./Components/MaintenantCardsV2";
import Voting from "./Components/Voting";
import Reunion from "./Components/Reunion";

class App extends Component {

    state = {
        voting: null,
        loading: true
    };

    componentDidMount() {
        this.fetchData();
    }

    fetchData() {
        fetch(window.EndPointData)
            .then(response => {
                return response.json()
            })
            .then(response => {
                this.setState({
                    loading: false,
                    voting: response
                });
            });
    }

    render() {
        if (this.state.loading) {
            return <Loading/>;
        }

        if (this.state.voting.displayMode === 'cards') {
            return <Cards voting={this.state.voting}/>
        } else if (this.state.voting.displayMode === 'table') {
            return <Table voting={this.state.voting}/>
        } else if (this.state.voting.displayMode === 'maintenantCards') {
            return <MaintenantCards voting={this.state.voting}/>
        } else if (this.state.voting.displayMode === 'maintenantCardsV2') {
            return <MaintenantCardsV2 voting={this.state.voting}/>
        } else if (this.state.voting.displayMode === 'voting') {
            return <Voting voting={this.state.voting} updateVoting={(voting) => {this.setState({voting})}}/>
        } else if (this.state.voting.displayMode === 'reunion') {
            return <Reunion voting={this.state.voting}/>
        }

        return (
            <Container>
                <Row>
                    <Col>
                        No format
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js